import React from 'react';

export default function Projects() {
  return (
    <div className="projects">Projects</div>
  );
}
